import axios from "axios";
import { environment } from "../../../environments/environment";
import{PAYMENT_TRANSCATION_URL} from "../../../constants/backendUrl";
import { PARTNER_SECURITY_URL } from "../../../constants/backendUrl";
import{REPORT_URL} from "../../../constants/backendUrl";
export class TransactionDetails {
  private static URL: any = environment.partnerApiUrl;

  
  public static getTransactionDetailsByPartnerId(partnerid:any, PageNumber: number, RowsOfPage: number,Key:any) {
    
    let PartnerURL: string = `${this.URL}/${PAYMENT_TRANSCATION_URL.getPaymentTransaction}?PartnerId=${partnerid}&PageNumber=${PageNumber}&RowsOfPage=${RowsOfPage}&Key=${Key}`;

    const config = {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
    };
    return axios.get<any>(PartnerURL, config);

}
public static getReportsDetails(startDate:any, endDate:any, partnerID: any) {
  let PartnerURL: string = `${this.URL}/${REPORT_URL.getReportData}/${partnerID}/${startDate}/${endDate}`;
  const decodedUrl = decodeURIComponent(PartnerURL);
// Replace datetime with only the date part
const updatedUrl = decodedUrl.replace(/(\d{4}-\d{2}-\d{2})\s+\d{2}:\d{2}:\d{2}/g, (match, date) => date);
  const config = {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
  };
  return axios.get<any>(updatedUrl, config);
}

public static downloadReportsDetails(startDate:any, endDate:any, partnerID:any) {
  let PartnerURL: string = `${this.URL}/${REPORT_URL.downloadReportsDetails}/${partnerID}/${startDate}/${endDate}`;
    const decodedUrl = decodeURIComponent(PartnerURL);
    // Replace datetime with only the date part
    const updatedUrl = decodedUrl.replace(/(\d{4}-\d{2}-\d{2})\s+\d{2}:\d{2}:\d{2}/g, (match, date) => date);
    const config = {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
    };
    return axios.get<any>(updatedUrl, config);
}

  // Payment detalils as per payment id 
public static getDetailPaymentId(paymentId: number, partnerId: any) {

let PartnerURL: string = `${this.URL}/${PAYMENT_TRANSCATION_URL.getTransactionByPaymentId}/${paymentId}/${partnerId}`;

const config = {
headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
};
return axios.get<any>(PartnerURL, config);

}

public static getPaymentLogs = (paymentid: number,includeDetails: boolean = false) => 
{
  let UserURL: string = `${this.URL}/${PARTNER_SECURITY_URL.getPaymentLogs}?paymentId=${paymentid}&includeDetails=${includeDetails}`;
  const config = {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
  };
  return axios.get<any>(UserURL, config);
};
}
